import { gql } from 'apollo-angular';

export const GET_ONE_WORK_ORDER = gql`
  query workOrder($id: Int!) {
    workOrder(id: $id) {
      id
      workOrderStatus
      workOrderNo
      partnerId
      subTotal
      totalAmount
      partnerData {
        id
        displayName
        addresses {
          id
          attention
          addressType
          addressLine1
          addressLine2
          city
          state
          country
          pinCode
          phone
          fax
        }
      }
      projectId
      projectData {
        id
        projectName
      }
      SOW
      clientRef
      duration
      startDate
      commencementDate
      completionDate
      projectManagerId
      projectManagerData {
        id
        firstName
        lastName
        middleName
        status
      }
      projectInchargeId
      projectInchargeData {
        id
        firstName
        lastName
        middleName
        status
      }
      projectDesigner
      projectDesignerData {
        id
        firstName
        lastName
        middleName
        status
      }
      procurementIncharge
      procurementInchargeData {
        id
        firstName
        lastName
        middleName
        status
      }
      estimator
      estimatorData {
        id
        firstName
        lastName
        middleName
        status
      }
      quoteId
      quoteData {
        id
        quoteCode
        parentQuoteId
        parentQuoteData {
          id
        }
        quoteItems {
          amount
          description
          unit
          quantity
          rate
          amount
        }
      }
      addressId
      addressData {
        id
        partnerId
        attention
        addressType
        addressLine1
        addressLine2
        city
        state
        country
        pinCode
        phone
        fax
      }
      status
      createdAt
      updatedAt
      workOrderSOWs {
        id
        workOrderId
        order
        unit
        quantity
        rate
        netPrice
        discount
        subTotal
        tax
        totalAmount
        status
      }
      attachedFiles {
        id
        workOrderId
        type
        fileName
        fileUrl
      }
    }
  }
`;

export const GET_ALL_WORK_ORDERS = gql`
  query workOrders(
    $search: String
    $projectId: Float
    $startDate: DateTime
    $endDate: DateTime
  ) {
    workOrders(
      search: $search
      projectId: $projectId
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      workOrderStatus
      workOrderNo
      partnerId
      partnerData {
        id
        displayName
        addresses {
          id
          addressType
          addressLine1
          addressLine2
          attention
          city
          country
          fax
          state
        }
      }
      # projectId
      projectData {
        id
        projectName
      }
      SOW
      clientRef
      duration
      commencementDate
      completionDate
      startDate
      projectManagerId
      projectManagerData {
        id
        firstName
        lastName
        middleName
        status
      }
      projectInchargeId
      projectInchargeData {
        id
        firstName
        lastName
        middleName
        status
      }
      projectDesigner
      projectDesignerData {
        id
        firstName
        lastName
        middleName
        status
      }
      procurementIncharge
      procurementInchargeData {
        id
        firstName
        lastName
        middleName
        status
      }
      estimator
      estimatorData {
        id
        firstName
        lastName
        middleName
        status
      }
      quoteId
      quoteData {
        id
        quoteCode
        branchData {
          id
          branchName
        }
        quoteItems {
          amount
          description
          unit
          quantity
          rate
          amount
        }
      }
      addressId
      addressData {
        id
        partnerId
        attention
        addressType
        addressLine1
        addressLine2
        city
        state
        country
        pinCode
        phone
        fax
      }
      status
      createdAt
      updatedAt
      workOrderSOWs {
        id
        workOrderId
        order
        quantity
        discount
        unit
        rate
        netPrice
        status
      }
      attachedFiles {
        id
        workOrderId
        type
        fileName
        fileUrl
      }
      subTotal
      tax
      totalAmount
    }
  }
`;

export const GENERATE_PDF = gql`
  query generateWorkOrderPdf($workOrderId: Int!, $withPrice: Boolean!) {
    generateWorkOrderPdf(workOrderId: $workOrderId, withPrice: $withPrice)
  }
`;

export const GET_ALL_SALES_ORDERS = gql`
  query orders($search: String) {
    orders(search: $search) {
      id
      branchId
      branchData {
        id
        branchName
        address
        branchCode
      }
      quoteId
      quoteData {
        id
        quoteCode
        quoteDate
        subTotal
        tax
        discount
        totalAmount
        discountValue
        discountReason
        approvalDate
      }
      customerData {
        id
        firstName
        lastName
        email
        phoneNumber
        address
        city
        state
        country
        zipCode
        dateOfBirth
      }
      orderCode
      orderDate
      totalAmount
      received
      balance
      refund
      paymentStatus
      isRefund
      reason
      status
    }
  }
`;

export const GET_ONE_SALES_ORDER = gql`
  query order($id: Int!) {
    order(id: $id) {
      id
      branchId
      quoteId
      quoteData {
        id
        quoteCode
      }
      customerId
      customerData {
        id
        firstName
        lastName
      }
      orderCode
      orderDate
      totalAmount
      balance
      status
      priority
    }
  }
`;

export const GET_ONE_DESIGNATION = gql`
  query findOneByDesignation($designationName: String) {
    findOneByDesignation(designationName: $designationName) {
      id
      designationName
      employees {
        id
        firstName
        lastName
      }
      status
      isApprover
    }
  }
`;

export const GET_TASK_TIMELINE_FOR_ORDER = gql`
  query getTaskTimelinesForAnOrder($orderId: Int!) {
    getTaskTimelinesForAnOrder(orderId: $orderId) {
      id
      assignmentId
      actionType
      actorId
      actorData {
        id
        firstName
        lastName
      }
      assignmentData {
        id
        variantName
        estimatedTime
        serviceTaskData {
          taskData {
            id
            taskName
            taskCode
          }
        }
      }
      message
      createdAt
    }
  }
`;

export const SERVICE_TASK_ASSIGNMENTS = gql`
  query serviceTaskAssignment($id: Int!) {
    serviceTaskAssignment(id: $id) {
      id
      serviceTaskId
      serviceTaskData {
        id
        serviceId
        taskId
        taskData {
          id
          taskName
          taskCode
          taskCheckListItems {
            id
            taskId
            itemName

            status
          }
        }
        isMandatory
        sequenceOrder
      }
      employeeId
      employeeData {
        id
        firstName
        lastName
      }
      serviceTaskStatus
      estimatedTime
      variantName
    }
  }
`;

export const TASK_TIMELINES = gql`
  query taskTimelines(
    $search: String
    $assignmentId: Int!
    $actionTypes: [ActionType!]
  ) {
    taskTimelines(
      search: $search
      assignmentId: $assignmentId
      actionTypes: $actionTypes
    ) {
      id
      assignmentId
      message
      attachmentUrls
      meta
      actionType
      createdAt
      actorData {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_ALL_IN_PROGRESS_SERVICE_TASK_ASSIGNMENTS = gql`
  query getAllInProgressServiceTaskAssignmentsForAnOrder($orderId: Int!) {
    getAllInProgressServiceTaskAssignmentsForAnOrder(orderId: $orderId) {
      id
      serviceTaskId
      serviceTaskData {
        id
        serviceId
        taskId
        taskData {
          taskName
        }
      }
      employeeId
      employeeData {
        id
        firstName
        lastName
      }
      serviceTaskStatus
      startedAt
      endedAt
      deadline
      timeSpent
      isLocked
    }
  }
`;

export const ORDER_SERVICES = gql`
  query orderServices($search: String, $orderId: Int!) {
    orderServices(search: $search, orderId: $orderId) {
      id
      serviceId
      serviceData {
        id
        branchId
        serviceName
        serviceCode
        departmentId
      }
      # orderData{
      # status
      # }
      serviceStatus
      serviceTaskAssignments {
        id
        orderServiceId
        serviceTaskId
        serviceTaskData {
          taskData {
            taskName
            taskCode
          }
        }
        employeeId
        employeeData {
          firstName
          lastName
        }
        serviceTaskStatus
        deadline
      }
    }
  }
`;

export const FIND_ALL_ORDERS_PAGINATION = gql`
  query findAllOrdersWithPagination($input: OrderPaginationInput) {
    findAllOrdersWithPagination(input: $input) {
      orders {
        id
        branchId
        quoteId
        quoteData {
          quoteCode
        }
        customerId
        customerData {
          id
          firstName
          lastName
        }
        orderCode
        orderDate
        totalAmount
        received
        balance
        refund
        paymentStatus
        isRefund
        reason
        status
        createdAt
        updatedAt
      }
      total
      skip
      limit
    }
  }
`;

export const SERVICE_TASK_LIST_FOR_EMPLOYEE = gql`
  query findAllTaskAssignmentsWithPagination(
    $input: TaskAssignmentPaginationInput
  ) {
    findAllTaskAssignmentsWithPagination(input: $input) {
      taskAssignments {
        id
        orderServiceId
        orderServiceData {
          orderData {
            id
            orderCode
          }
        }
        employeeId
        employeeData {
          id
          firstName
          lastName
        }
        serviceTaskId
        serviceTaskData {
          id
          taskId
          taskData {
            taskName
            taskCode
          }
        }
        serviceTaskStatus
        deadline
        estimatedTime
        variantName
      }
      total
      skip
      limit
    }
  }
`;
